export const releaseInfo = {
    version: '4a138863',
}
